export const LIST_ME_GYMS = 'LIST_ME_GYMS';
export const CHANGE_GYM = 'CHANGE_GYM';
